"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIComponent = require("../../components/UIComponent.js"),
    template = require("./StaticPanel.html");
var StaticPanel = function (_UIComponent) {
  _inherits(StaticPanel, _UIComponent);

  function StaticPanel(e) {
    _classCallCheck(this, StaticPanel);

    return _possibleConstructorReturn(this, (StaticPanel.__proto__ || Object.getPrototypeOf(StaticPanel)).call(this, e || template));
  }

  return StaticPanel;
}(UIComponent);

module.exports = StaticPanel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0YXRpY1BhbmVsLmpzIl0sIm5hbWVzIjpbIlVJQ29tcG9uZW50IiwicmVxdWlyZSIsInRlbXBsYXRlIiwiU3RhdGljUGFuZWwiLCJbb2JqZWN0IE9iamVjdF0iLCJjaGlsZFRlbXBsYXRlIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQSxJQUFNQSxjQUFjQyxRQUFRLGlDQUFSQSxDQUFwQjtBQUFBLElBQ01DLFdBQVdELFFBQVEsb0JBQVJBLENBRGpCO0lBR01FLFc7OztBQUNGQyx1QkFBWUMsQ0FBWkQsRUFBWUM7QUFBQUE7O0FBQUFBLHFIQUNMQSxLQUlPSCxRQUxGRztBQUtFSDs7O0VBTlFGLFc7O0FBVzFCTSxPQUFPQyxPQUFQRCxHQUFpQkgsV0FBakJHIn0=